/* =========================================
   SQUALO Cart Cross-sell — "ACOMPAÑA TU LOOK"
   - Add desde la tarjeta sin cerrar el drawer
   - Mismo patron que squalo-quick-add.js: /cart/add.js -> renderContents()
   - El bloque vive dentro de .cart-drawer__footer, asi que se recalcula solo
     en cada cambio del carrito (Section Rendering API).
   ========================================= */
(function () {
  'use strict';

  const cartTarget = () =>
    document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  /* ---- Add to cart desde la tarjeta de cross-sell ---- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cross-sell-add]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.classList.contains('is-loading')) return;

    const card = btn.closest('[data-cross-sell-card]');
    if (!card) return;

    // El select deshabilitado (gorra "Talla única") se ignora: usamos el input oculto.
    const select = card.querySelector('.cross-sell__select:not([disabled])');
    const hidden = card.querySelector('.cross-sell__variant');
    const variantId = (select && select.value) || (hidden && hidden.value);
    if (!variantId) return;

    btn.classList.add('is-loading');

    const cart = cartTarget();
    const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (cart && typeof cart.getSectionsToRender === 'function') {
      const sectionIds = cart.getSectionsToRender().map((s) => s.id).join(',');
      formData.append('sections', sectionIds);
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    try {
      const res = await fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const data = await res.json();

      if (data.status) {
        btn.classList.remove('is-loading');
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartError, {
            source: 'cart-cross-sell',
            productVariantId: variantId,
            errors: data.errors || data.description,
            message: data.message,
          });
        }
        return;
      }

      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.blur();

      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-cross-sell',
          productVariantId: variantId,
          cartData: data,
        });
      }

      if (cart && typeof cart.renderContents === 'function') {
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(data);
      }
    } catch (err) {
      btn.classList.remove('is-loading');
      console.error('[cart-cross-sell] add failed', err);
    }
  });

  /* ---- Flechas (desktop): desplazan el track ---- */
  const updateArrows = (root) => {
    const track = root.querySelector('[data-cross-sell-track]');
    const prev = root.querySelector('[data-cross-sell-prev]');
    const next = root.querySelector('[data-cross-sell-next]');
    if (!track || !prev || !next) return;

    const maxScroll = track.scrollWidth - track.clientWidth - 1;
    prev.hidden = track.scrollLeft <= 0;
    next.hidden = track.scrollLeft >= maxScroll;
  };

  document.addEventListener('click', (e) => {
    const arrow = e.target.closest('[data-cross-sell-prev], [data-cross-sell-next]');
    if (!arrow) return;

    const root = arrow.closest('[data-cross-sell]');
    const track = root && root.querySelector('[data-cross-sell-track]');
    if (!track) return;

    const card = track.querySelector('[data-cross-sell-card]');
    const step = card ? card.offsetWidth + 16 : track.clientWidth;
    const dir = arrow.hasAttribute('data-cross-sell-next') ? 1 : -1;
    track.scrollBy({ left: step * dir, behavior: 'smooth' });
  });

  /* El cross-sell se re-renderiza con el drawer; re-evaluamos flechas. */
  const initAll = () => {
    document.querySelectorAll('[data-cross-sell]').forEach((root) => {
      const track = root.querySelector('[data-cross-sell-track]');
      if (!track || track.dataset.csBound === 'true') return;
      track.dataset.csBound = 'true';
      track.addEventListener('scroll', () => updateArrows(root), { passive: true });
      updateArrows(root);
    });
  };

  document.addEventListener('DOMContentLoaded', initAll);
  // El drawer reemplaza el DOM al actualizar el carrito: re-bind en cada cambio.
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => setTimeout(initAll, 50));
  }
  // Fallback por si los modulos aun no cargaron.
  document.addEventListener('click', () => setTimeout(initAll, 100), { once: true });
})();
